const chunkIt = (sep, imgTarget) => {
    $.each(sep, function(index, chunk) {
        if (index === 0) {
            imgTarget.wrap('<div class="chunk">');
            return;
        }
        if($(imgTarget).attr('src').length > 0){
        	var mainImgSplit = $(imgTarget).attr('src').split('/');
        	mainImgSplit[mainImgSplit.length -1] = chunk;
        	imgTarget.parents('.product-link').append(`<div class="chunk"><img src="" data-alts="${mainImgSplit.join('/')}.jpg"/></div>`);
        }
    });
}

const slickWrap = (that) => {
    that.children().wrapAll('<div class="slickWrapper"></div>');
}

const imgSwipe_productresults = (slickTarget, selector, prodId) => {
    slickTarget.each(function() {
        slickWrap($(this));
    });
    let getSelector = (prodId === undefined || prodId === 0) ? $(selector) : $(`#${prodId}`).find(selector);
    getSelector.each(function() {
				$(this).not('.slick-initialized').slick({
						arrows: false,
						dots: true,
            infinite: false
				});
        $(this).on('swipe', function(event, slick, direction) {
            $(this).find('.chunk img').each(function() {
                $(this).attr("src", $(this).data('alts'));
            });
        });
    });
}

const imgSwipe = (prodId = 0, dataAlts = 0) => {
    if (prodId === undefined || prodId === 0) {
        let $imgTarget = $('.wrapper-item .product-img-wrapper .product-img'),
            $slickTarget = $('.wrapper-item .product-img-wrapper a.product-link');
        $imgTarget.each(function() {
            let $imgTarget = $(this),
                altStrings = $imgTarget.data('alternates'),
                sep = altStrings.split('|'),
                firstFive = sep.slice(0, 5);
            chunkIt(firstFive, $imgTarget);
        });
        imgSwipe_productresults($slickTarget, '.wrapper-item .product-img-wrapper a.product-link .slickWrapper', prodId);
    } else {
        let $imgTarget = $(`#${prodId} .product-img-wrapper .product-img`),
            $slickTarget = $(`#${prodId}  .product-img-wrapper a.product-link`),
            sep = dataAlts.split('|'),
            firstFive = sep.slice(0, 5);
        chunkIt(firstFive, $imgTarget);
        imgSwipe_productresults($slickTarget, '.product-img-wrapper a.product-link .slickWrapper', prodId);
    }
}

export {
    imgSwipe,
    slickWrap
}
